import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import ImageUpload from '@components/ImageUpload';
import { toastError, toastSuccess } from '@components/Toast';

import { fetchCostingDetails } from '@store/actions/CostingAction';
import { fetchMoodBoardDetails } from '@store/actions/MoodboardAction';

import ApiClient from '@lib/apiClient';

import { getFileType, getIconByFileType, getShortName, isValidInput } from '@utils/Util';

const TopDetails = ({ description, documentLists = [], moodboardId, type }) => {
	const [newDescription, setnewDescription] = useState('');
	const [isEdit, setEdit] = useState(false);
	const { id } = useParams();
	const valueBefore = useRef(null);
	const dispatch = useDispatch();

	const IMAGE_TYPES = ['IMAGE', 'NO_FILE'];

	useEffect(() => {
		setnewDescription(description);
	}, [description]);

	const onUpdate = async (image = null) => {
		const body = {
			description: newDescription,
			id: moodboardId
		};
		if (image) {
			body.documentDTOs = [image];
		}
		try {
			const { data } = await ApiClient.PUT('updateMoodboardDetails', body);
			setEdit(false);
			if (image) {
				dispatch(fetchMoodBoardDetails(moodboardId));
			}
			toastSuccess(data.message);
		} catch ({ error }) {
			if (error && error.data && error.data.message) {
				toastError(error.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onUpdateQuoteDescription = async () => {
		const body = {
			description: newDescription
		};
		try {
			const { data } = await ApiClient.PATCH('quoteAction', body, `${id}/update-description`);
			setEdit(false);
			toastSuccess(data.message);
		} catch (error) {
			if (error && error.data && error.data.message) {
				toastError(error.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onUpdateSampleDescription = async () => {
		const body = {
			description: newDescription
		};
		try {
			const { data } = await ApiClient.PATCH('sampleDetailsAction', body, `${id}`);
			setEdit(false);
			toastSuccess(data.message);
		} catch ({ error }) {
			if (error && error.data && error.data.message) {
				toastError(error.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onUpdateDescription = (e) => {
		if (!isValidInput(valueBefore, e)) {
			valueBefore.current = null;
			setEdit(false);
		} else {
			if (type === 'MOODBOARD') {
				onUpdate();
			}
			if (type === 'QUOTE') {
				onUpdateQuoteDescription();
			}
			if (type === 'SAMPLE') {
				onUpdateSampleDescription();
			}
		}
	};

	const onAddFileToQuote = async (image) => {
		try {
			const { data } = await ApiClient.POST('quoteAction', [image], `${id}/documents`);
			setEdit(false);
			dispatch(fetchCostingDetails(id));
			toastSuccess(data.message);
		} catch ({ error }) {
			if (error && error.data && error.data.message) {
				toastError(error.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onAddFileToSample = async (image) => {
		try {
			const { data } = await ApiClient.POST('sampleDetailsAction', [image], `${id}/documents`);
			setEdit(false);
			// fetchSampleDetails();
			toastSuccess(data.message);
		} catch ({ error }) {
			if (error && error.data && error.data.message) {
				toastError(error.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onAddFile = (image) => {
		if (type === 'MOODBOARD') {
			onUpdate(image);
		}
		if (type === 'QUOTE') {
			onAddFileToQuote(image);
		}
		if (type === 'SAMPLE') {
			onAddFileToSample(image);
		}
	};

	const getDocType = {
		MOODBOARD: 'MOODBOARD_FILE',
		QUOTE: 'QUOTE_REQUESTED_DOCUMENT',
		SAMPLE: 'SAMPLE_REQUESTED_DOCUMENT'
	};

	return (
		<div className="common-description-box mb-3">
			<p className="semibold-14 mb-2">Description</p>
			<div className="info-details" onClick={() => setEdit(true)}>
				<textarea
					className={`${isEdit ? 'cursor-pointer' : ''}`}
					name="description"
					placeholder="Write collection description"
					value={newDescription}
					rows="3"
					type="text"
					autoComplete="off"
					onChange={(e) => setnewDescription(e.target.value)}
					onBlur={(e) => onUpdateDescription(e)}
					onFocus={(event) => (valueBefore.current = event.target.value)}
				/>
			</div>

			<div className="uploaded-files d-flex align-items-center">
				<div className="d-flex mr-5">
					<ImageUpload
						onUploadImage={(image) => onAddFile(image)}
						docType={getDocType[type]}
						type={'imageAndPdf'}
						isEditable={true}
					/>
					<span className="pl-2">File</span>
				</div>

				{documentLists.length > 0 && (
					<ul>
						{documentLists?.map((item, idx) => (
							<li key={item.id}>
								<img
									src={
										IMAGE_TYPES.includes(getFileType(item.docUrl))
											? item.docUrl
											: getIconByFileType(getFileType(item.docUrl))
									}
									alt={`Document ${idx}`}
								/>
								<Link
									to={{ pathname: item.docUrl }}
									target="_blank"
									className="regular-12 gray_dark_02"
								>
									{getShortName(item.name, 13)}
								</Link>
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

export default TopDetails;
